import React from 'react';
import './checkbox.scss';
import Label from '../../Label';

export default function Checkbox(props) {
  const {label, id, name, value, checked, containerStyle, onChange} = props;
  return (
    <div style={containerStyle} className="checkbox-container">
      <input type="checkbox" id={id} name={name} value={value} checked={checked} onChange={onChange} />
      <Label style={{marginLeft: 5, display: 'inline'}}>{label}</Label>
    </div>
  );
}
